import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Breadcrumb from '@softwaredev_cegeka/stix-core/dist/components/Breadcrumb'

import styles from './crumbs.module.scss'

class Crumbs extends Component {
    // TODO Create decent breadcrumb name paths
    // TODO Add react dom Link features to breadcrumb links.
    render() {
        const { path } = this.props

        // remove /articles from the routes
        let breadcrumbPath = path.split('/')
        if (breadcrumbPath[1] === 'articles') {
            breadcrumbPath.splice(1, 1)
        }
        // replace breadcrumb for edit page
        if (breadcrumbPath[2] === ':id') {
            breadcrumbPath = ['', `edit-${this.props.match.params.id}`]
        }

        return (
            <Breadcrumb className={styles.crumbs}>
                {breadcrumbPath.map((item, index) => {
                    if (item === '') {
                        return (
                            <Breadcrumb.HomeItem
                                className={styles.item}
                                key={index}
                                linkAs={Link}
                                linkProps={{
                                    to: '/',
                                }}
                            />
                        )
                    }
                    return (
                        <Breadcrumb.Item
                            className={styles.item}
                            active={index === breadcrumbPath.length - 1}
                            key={index}
                        >
                            {item}
                        </Breadcrumb.Item>
                    )
                })}
            </Breadcrumb>
        )
    }
}

export default Crumbs
